// extracted by mini-css-extract-plugin
export var card = "_j4-5";
export var cardSelected = "_j4-4";
export var image = "_j4-3";
export var modal = "_j4-0";
export var modalContent = "_j4-1";
export var table = "_j4-2";